import { render, staticRenderFns } from "./DetailMessage.vue?vue&type=template&id=3464d602&scoped=true&"
import script from "./DetailMessage.vue?vue&type=script&setup=true&lang=js&"
export * from "./DetailMessage.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DetailMessage.vue?vue&type=style&index=0&id=3464d602&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._qkvgvrmvpkafkn37suro37nope/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3464d602",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_gys_admin_online_docker/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3464d602')) {
      api.createRecord('3464d602', component.options)
    } else {
      api.reload('3464d602', component.options)
    }
    module.hot.accept("./DetailMessage.vue?vue&type=template&id=3464d602&scoped=true&", function () {
      api.rerender('3464d602', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nb/order/components/orderDetail/DetailMessage.vue"
export default component.exports